import { render, staticRenderFns } from "./getUser copy.vue?vue&type=template&id=b56b1fae&"
import script from "./getUser copy.vue?vue&type=script&lang=js&"
export * from "./getUser copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports